export const CREATED_TIME_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "This Week", value: "This Week" },
  { label: "This Month", value: "This Month" },
  { label: "Last Week", value: "Last Week" },
  { label: "Last Month", value: "Last Month" },
  { label: "Custom", value: "Custom" },
];